import { Profesional as IProfesional } from 'src/interfaces'

type Props = {
  profesional: IProfesional
}

function Profesional({ profesional }: Props): JSX.Element {
  const info = `${profesional.nombre} ${profesional.apellido1 ?? ''} [${profesional.nif}]`
  return (
    <div>
      {profesional.nombre && (
        <div>
          <strong>Profesional: </strong>
          <span>{info}</span>
        </div>
      )}
      <div>
        <strong>Código colegiado: </strong>
        <span>{profesional.codigoColegiado}</span>
      </div>
    </div>
  )
}

export default Profesional
